/**
 * @fileoverview POST handler for the "/users/subscription_groups/:id" endpoint
 */
import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { usersSubscriptionGroupsIdCacheKeys } from "./constants";
import type {
  PostUsersSubscriptionGroupsIdErrors,
  PostUsersSubscriptionGroupsIdProps,
  UsersSubscriptionGroupsIdResult,
} from "./types";

export const postUsersSubscriptionGroupsId = reactQueryMutationAdapter(
  usersSubscriptionGroupsIdCacheKeys,
  createMutationFetcherFunctionWithShadowError<PostUsersSubscriptionGroupsIdErrors>()(
    (props: PostUsersSubscriptionGroupsIdProps): Promise<UsersSubscriptionGroupsIdResult> => {
      return fetch(`/users/subscription_groups/${props.id || ""}`, "POST", props, undefined, {
        propagateFetchRequestError: false,
      });
    }
  )
);
